<template>
  <!--活动满减满赠组件-->
  <div
    v-if="skuModel && skuModel.showActivity"
    class="con border_bottom1px_shadow flex_layout"
    @click="showActive"
  >
    <!-- 左侧标题 -->
    <div class="left_title font12 font_weight400 colo055">活动</div>

    <!-- 中间活动列表与赠品缩略图 -->
    <div class="middle_content">
      <!-- 活动列表 -->
      <div class="activity_list">
        <!-- 奖励翻倍 -->
        <div v-if="skuModel.showCharge" class="activity_item">
          <span class="tag_charge font10">佣金翻倍</span>
          <span class="activity_desc font12 colo087"
            >额外佣金 ￥{{ skuModel.chargeAmount || 0 }}</span
          >
        </div>

        <!-- 优惠券 -->
        <template v-if="skuModel.showCoupon">
          <div
            v-for="(coupon, idx) in skuModel.couponProductList"
            :key="'coupon-' + idx"
            class="activity_item"
          >
            <span class="tag_coupon font10"
              >{{ coupon.couponTypeStr || "" }}券</span
            >
            <span class="activity_desc font12 colo087">{{
              coupon.couponMessageStr || ""
            }}</span>
          </div>
        </template>

        <!-- 买赠 -->
        <div v-if="skuModel.gift" class="activity_item">
          <span class="tag_gift font10">买赠</span>
          <span class="activity_desc font12 colo087">{{
            skuModel.gift.name || ""
          }}</span>
        </div>
      </div>

      <!-- 赠品缩略图列表 -->
      <div
        v-if="skuModel.gift && skuModel.gift.gift && skuModel.gift.gift.length"
        class="gift_images_wrapper"
      >
        <div class="gift_images">
          <div
            v-for="(spu, idx) in giftDisplayList"
            :key="'gift-img-' + idx"
            class="gift_image_item"
          >
            <img :src="getGiftImg(spu)" class="gift_img" alt="" />
            <div v-if="!hasStock(spu)" class="out_of_stock font10">赠完</div>
          </div>
        </div>
        <div class="gift_count_tag font12">
          共{{ skuModel.gift.gift.length }}件赠品可选
        </div>
      </div>
    </div>

    <!-- 右侧箭头 -->
    <img
      src="@/assets/common/icon_back_b87_24@2x.png"
      alt=""
      class="right_icon"
    />
  </div>
</template>

<script>
export default {
  props: {
    skuModel: {
      type: Object,
      default: null
    },
    checkGiftList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  computed: {
    giftDisplayList() {
      if (!this.skuModel || !this.skuModel.gift || !this.skuModel.gift.gift) {
        return [];
      }
      return this.skuModel.gift.gift.slice(0, 5);
    }
  },
  methods: {
    showActive() {
      this.$emit("showActive");
    },
    getGiftSku(spu) {
      if (!spu.skus) return null;
      if (!this.checkGiftList || !this.checkGiftList.length) {
        return Object.values(spu.skus)[0] || null;
      }
      const found = this.checkGiftList.find(item => item.spuId === spu.id);
      if (found) {
        return (
          Object.values(spu.skus).find(s => s.id === found.skuId) ||
          Object.values(spu.skus)[0] ||
          null
        );
      }
      return Object.values(spu.skus)[0] || null;
    },
    getGiftImg(spu) {
      const sku = this.getGiftSku(spu);
      if (sku) {
        return sku.attributeImg || sku.thumbnailImg || spu.thumbnailImg || "";
      }
      return spu.thumbnailImg || "";
    },
    hasStock(spu) {
      const sku = this.getGiftSku(spu);
      return spu.stock > 0 && sku !== null;
    }
  }
};
</script>

<style lang="less" scoped>
.con {
  background: #fff;
  padding: 13px 0 10px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  box-sizing: border-box;

  .left_title {
    width: 35px;
    line-height: 17px;
    margin-right: 15px;
    flex-shrink: 0;
    text-align: left;
  }
  .middle_content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .right_icon {
    width: 24px;
    flex-shrink: 0;
    margin-left: 8px;
    align-self: center;
  }

  // 活动列表项
  .activity_list {
    display: flex;
    flex-direction: column;
  }
  .activity_item {
    display: flex;
    align-items: center;
    margin-bottom: 6px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .activity_desc {
    color: #262626;
    line-height: 14px;
    text-align: left;
  }

  // 活动标签公用
  .tag_charge,
  .tag_coupon,
  .tag_gift {
    color: #fff;
    padding: 1px 4px;
    border-radius: 1px;
    margin-right: 8px;
    line-height: 11px;
    height: 14px;
    box-sizing: border-box;
    display: inline-block;
    flex-shrink: 0;
  }

  // 佣金翻倍标签样式
  .tag_charge {
    background: linear-gradient(270deg, #dd1142 0%, #be020a 100%);
  }
  // 优惠券标签样式
  .tag_coupon {
    background: linear-gradient(90deg, #fb275a 0%, #ff5d84 100%);
  }
  // 买赠标签样式
  .tag_gift {
    background: linear-gradient(270deg, #ff5f05 0%, #ff8514 100%);
  }

  // 赠品图片列表样式
  .gift_images_wrapper {
    margin-top: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .gift_images {
    display: flex;
    align-items: center;
  }
  .gift_image_item {
    position: relative;
    width: 30px;
    height: 30px;
    margin-right: 5px;
    flex-shrink: 0;
  }
  .gift_img {
    width: 30px;
    height: 30px;
    border-radius: 1px;
    object-fit: cover;
  }
  .out_of_stock {
    position: absolute;
    bottom: 0;
    left: 1px;
    width: 28px;
    height: 14px;
    background: rgba(0, 0, 0, 0.9);
    color: #fff;
    line-height: 14px;
    text-align: center;
    border-radius: 1px;
  }
  .gift_count_tag {
    background: #f9f9f9;
    color: #bfbfbf;
    padding: 4px 8px;
    line-height: 12px;
    border-radius: 1px;
    flex-shrink: 0;
  }
}
</style>
